import { toNumber } from 'lodash'

import { AuctionDetail, PropertyEntity } from '@eastcoal/api/trade/interface'

import { HouseAuctionForm } from '../types/form'

export type HouseAuctionFormData = Omit<HouseAuctionForm, 'taxRate'> & {
  taxRate?: string
}

export const formatDetail = ({
  productProperties,
  ...restData
}: AuctionDetail) => {
  const formData = restData as HouseAuctionFormData
  productProperties?.forEach(({ name, value }) => {
    if (name) {
      formData[name] = value
    }
  })
  return {
    ...formData,
    taxRate: `${formData.taxRate}`
  }
}

export const formatFormData = ({
  cityId,
  cityName,
  address,
  type,
  purpose,
  buildingArea,
  availableArea,
  room,
  hall,
  propertyRight,
  leaseTermYear,
  leaseTermMonth,
  taxRate,
  priorityId,
  priorityName,
  ...restData
}: HouseAuctionFormData) => {
  return {
    ...restData,
    taxRate: toNumber(taxRate),
    productProperties: [
      {
        name: 'address',
        value: address
      },
      {
        name: 'type',
        value: type
      },
      {
        name: 'purpose',
        value: purpose
      },
      {
        name: 'buildingArea',
        value: buildingArea
      },
      {
        name: 'availableArea',
        value: availableArea
      },
      {
        name: 'room',
        value: room
      },
      {
        name: 'hall',
        value: hall
      },
      {
        name: 'propertyRight',
        value: propertyRight
      },
      {
        name: 'leaseTermYear',
        value: leaseTermYear
      },
      {
        name: 'leaseTermMonth',
        value: leaseTermMonth
      },
      {
        name: 'priorityId',
        value: priorityId
      },
      {
        name: 'priorityName',
        value: priorityName
      }
    ] as PropertyEntity[]
  }
}
